import { SxProps } from '@mui/material';

export const bundlePriceSx: SxProps = () => ({
	borderBottom: '1px solid',
	borderColor: 'grey.300',
	paddingBottom: '10px',
});
export const bundlePriceContainerSx: SxProps = () => ({
	margin: '0 5px 15px 5px',
});

export const productPriceSx: SxProps = () => ({ minHeight: '60px', marginBottom: '15px' });
